import React from 'react';
import InputField from '../../Reusable/InputField';
import withTranslations from '../../../utils/HighOrderComponent';
import { Col, Row } from 'react-bootstrap';
import Tooltip from '@material-ui/core/Tooltip';
import { autonomousProvinces } from '../../../constants/globals';
import ComboBoxAutocomplete from '../../Reusable/ComboBoxAutocomplete';

const FirstStep = (props) => {
  const {
      loggedUser,
      changeComboAutocomplete,
      onChange,
      kjsMunicipality,
      place,
      municipality,
    } = props,
    { kjsList } = loggedUser || {};

  const { Placeholders, Tooltips } = props.t || {};
  let autonomousProvinceTranslate,
    municipalityFieldValue,
    placeFieldValue,
    identificationNumberFieldValue,
    pibFieldValue,
    uniqueNumberFieldValue;

  if (kjsMunicipality) {
    const { kjs } = kjsMunicipality;
    municipalityFieldValue = municipality?.name;
    placeFieldValue = place?.name;
    identificationNumberFieldValue = kjs?.identificationNumber;
    pibFieldValue = kjs?.pib;
    uniqueNumberFieldValue = kjs?.uniqueNumber;
    autonomousProvinceTranslate =
      autonomousProvinces[municipality?.place?.autonomousProvince]?.text;
  } else if (kjsList.length === 1) {
    municipalityFieldValue = kjsList[0]?.municipality?.name;
    placeFieldValue = kjsList[0]?.municipality?.place?.name;
    identificationNumberFieldValue = kjsList[0]?.kjs?.identificationNumber;
    pibFieldValue = kjsList[0]?.kjs?.pib;
    uniqueNumberFieldValue = kjsList[0]?.kjs?.uniqueNumber;
    autonomousProvinceTranslate =
      autonomousProvinces[kjsList[0]?.municipality?.place?.autonomousProvince]
        ?.text;
  }

  return (
    <Row>
      <Col md={6}>
        <div className="mt-3 form-group">
          {renderKjsField(
            kjsList,
            kjsMunicipality,
            Placeholders,
            changeComboAutocomplete,
            onChange
          )}
        </div>
        <div className="form-group">
          <InputField
            name="place"
            placeholder={Placeholders.place}
            onChange={props.onChange}
            disabled
            value={placeFieldValue}
          />
        </div>
        <Tooltip title={Tooltips.municipality} placement="top" arrow={true}>
          <div className="mt-3 form-group">
            <InputField
              name="municipality"
              placeholder={Placeholders.municipalities}
              onChange={props.onChange}
              disabled
              value={municipalityFieldValue}
            />
          </div>
        </Tooltip>
        <div className="form-group">
          <InputField
            name="countryName"
            value={props.countryName}
            placeholder={Placeholders.countryName}
            onChange={props.onChange}
            disabled
          />
        </div>
        {autonomousProvinceTranslate && (
          <div className="mt-3 form-group">
            <InputField
              name="autonomousProvince"
              placeholder={Placeholders.autonomousProvince}
              onChange={props.onChange}
              disabled
              value={autonomousProvinceTranslate}
            />
          </div>
        )}
      </Col>
      <Col md={6}>
        <div className="form-group">
          <InputField
            name="identificationNumber"
            placeholder={Placeholders.identificationNumber}
            onChange={props.onChange}
            disabled
            value={identificationNumberFieldValue}
          />
        </div>
        <div className="form-group">
          <InputField
            name="pib"
            placeholder={Placeholders.pib}
            onChange={props.onChange}
            value={pibFieldValue}
            disabled
          />
        </div>
        <div className="form-group">
          <InputField
            name="uniqueNumber"
            placeholder={Placeholders.uniqueNumber}
            onChange={props.onChange}
            value={uniqueNumberFieldValue}
            disabled
          />
        </div>

        <div className="text-center">
          <InputField
            name="organizationalUnit"
            placeholder={Placeholders.organizationalUnit1}
            onChange={props.onChange}
            value={props.organizationalUnit}
          />
          <InputField
            name="organizationalUnit2"
            placeholder={Placeholders.organizationalUnit2}
            onChange={props.onChange}
            value={props.organizationalUnit2}
          />
          <InputField
            name="organizationalUnit3"
            placeholder={Placeholders.organizationalUnit3}
            onChange={props.onChange}
            value={props.organizationalUnit3}
          />
          <InputField
            name="organizationalUnitPlace"
            placeholder={Placeholders.organizationalUnitPlace}
            onChange={props.onChange}
            value={props.organizationalUnitPlace}
          />
        </div>
      </Col>
    </Row>
  );
};

export default withTranslations(FirstStep, 'FirstStep');

const renderKjsField = (
  kjsList,
  kjsMunicipality,
  translations,
  changeComboAutocomplete,
  onChange
) => {
  return (
    kjsList &&
    (kjsList?.length > 1 ? (
      <ComboBoxAutocomplete
        data={kjsList}
        changeValue={(newValue) =>
          changeComboAutocomplete('kjsMunicipality', newValue)
        }
        placeholder={translations.kjs}
        text={(kjsMuni) => kjsMuni?.kjs?.name}
        required
        wholeObject
        updateValue={kjsMunicipality}
      />
    ) : (
      <InputField
        name="kjs"
        placeholder={translations.kjs}
        onChange={onChange}
        disabled
        value={kjsList[0]?.kjs?.name}
      />
    ))
  );
};
